(function () {
  'use strict';

  var DESKTOP_MIN_WIDTH = 1025;
  var menuCloseHandlers = new WeakMap();

  function isDesktop() {
    return window.innerWidth >= DESKTOP_MIN_WIDTH;
  }

  function setExpanded(item, expanded) {
    var trigger = item.querySelector('[data-ah-chair-trigger]');

    if (trigger) {
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }
  }

  function syncReview(rating) {
    var host = rating.querySelector('.stamped-product-reviews-badge');
    var badge = host && host.querySelector('.stamped-badge');
    var fallback = rating.querySelector('[data-ah-chair-rating-zero]');

    if (!host || !fallback) {
      return;
    }

    if (!badge || badge.getAttribute('data-rating') === null) {
      host.style.setProperty('display', 'none', 'important');
      fallback.hidden = false;
      return;
    }

    var ratingValue = parseFloat(badge.getAttribute('data-rating') || '0');

    host.querySelectorAll('.stamped-starrating, .stamped-badge-starrating, .stamped-starrating i, .stamped-badge-starrating i').forEach(function (star) {
      star.style.setProperty('color', '#19242e', 'important');
    });

    if (ratingValue > 0) {
      host.style.removeProperty('display');
      host.style.setProperty('visibility', 'visible', 'important');
      fallback.hidden = true;
      return;
    }

    host.style.setProperty('display', 'none', 'important');
    fallback.hidden = false;
  }

  function watchReviews(item) {
    item.querySelectorAll('[data-ah-chair-rating]').forEach(function (rating) {
      if (rating.hasAttribute('data-ah-chair-rating-ready')) {
        return;
      }

      rating.setAttribute('data-ah-chair-rating-ready', 'true');

      var observer = new MutationObserver(function () {
        syncReview(rating);
      });

      observer.observe(rating, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-rating']
      });

      syncReview(rating);
    });
  }

  function loadRedirectedPreview(panel) {
    var destination = panel.getAttribute('data-ah-chair-preview-url');

    if (!destination || panel.hasAttribute('data-ah-chair-preview-state')) {
      return;
    }

    // Liquid cannot resolve URL redirects. Request this theme's card section at
    // the saved URL so Shopify resolves the collection, including future redirects.
    var savedUrl = new URL(destination, window.location.origin);
    var url = new URL(savedUrl.pathname + savedUrl.search, window.location.origin);
    var sectionId = 'ah-chair-menu-preview';
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 10000);
    url.searchParams.set('section_id', sectionId);
    panel.setAttribute('data-ah-chair-preview-state', 'loading');
    panel.setAttribute('aria-busy', 'true');

    fetch(url.href, { credentials: 'same-origin', signal: controller.signal })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Preview unavailable');
        }

        var resolvedUrl = new URL(response.url);
        if (resolvedUrl.origin !== window.location.origin) {
          throw new Error('Preview destination is outside this storefront');
        }

        // Some saved redirects omit the query string from the destination.
        if (resolvedUrl.searchParams.get('section_id') !== sectionId) {
          resolvedUrl.searchParams.set('section_id', sectionId);
          return fetch(resolvedUrl.href, { credentials: 'same-origin', signal: controller.signal });
        }

        return response;
      })
      .then(function (response) {
        if (!response.ok || new URL(response.url).origin !== window.location.origin) {
          throw new Error('Preview unavailable');
        }
        return response.text();
      })
      .then(function (html) {
        var documentPreview = new DOMParser().parseFromString(html, 'text/html');
        var content = documentPreview.querySelector('[data-ah-chair-preview]');
        if (!content || !panel.isConnected) {
          throw new Error('Preview unavailable');
        }

        // Only update the requested panel, even if the shopper has since hovered another link.
        panel.replaceChildren.apply(panel, Array.from(content.children).map(function (child) {
          return document.importNode(child, true);
        }));
        panel.setAttribute('data-ah-chair-collection', content.getAttribute('data-ah-chair-collection'));
        panel.setAttribute('data-ah-chair-preview-state', 'loaded');
        watchReviews(panel);
        if (window.StampedFn && typeof window.StampedFn.loadBadges === 'function') {
          window.StampedFn.loadBadges();
        }
      })
      .catch(function () {
        // Leave the configured destination link usable when previews cannot load.
        panel.setAttribute('data-ah-chair-preview-state', 'unavailable');
      })
      .finally(function () {
        window.clearTimeout(timeout);
        panel.removeAttribute('aria-busy');
      });
  }

  function initialize(item) {
    if (item.hasAttribute('data-ah-chair-ready')) {
      return;
    }

    var trigger = item.querySelector('[data-ah-chair-trigger]');
    var menu = item.querySelector('[data-ah-chair-panel]');
    var tabs = Array.prototype.slice.call(item.querySelectorAll('[data-ah-chair-tab]'));
    var panels = Array.prototype.slice.call(item.querySelectorAll('[data-ah-chair-products]'));
    var closeTimer;
    var restoringFocus = false;

    if (!trigger || !menu || !tabs.length || !panels.length) {
      return;
    }

    item.setAttribute('data-ah-chair-ready', 'true');

    function open() {
      if (!isDesktop() || restoringFocus) {
        return;
      }

      // Keep one collection preview open even when another menu still has
      // keyboard focus or its delayed pointer-close timer has not fired yet.
      document.querySelectorAll('.header-bottom[data-sticky-pc] [data-ah-chair-menu].is-dropdown-open').forEach(function (otherItem) {
        if (otherItem !== item) {
          var closeOther = menuCloseHandlers.get(otherItem);
          if (closeOther) {
            closeOther();
          }
        }
      });

      window.clearTimeout(closeTimer);
      item.classList.add('is-dropdown-open');
      setExpanded(item, true);
      panels.forEach(function (panel) {
        if (!panel.hidden) {
          loadRedirectedPreview(panel);
        }
      });
    }

    function close(options) {
      if (options && options.restoreFocus) {
        restoringFocus = true;
        try {
          trigger.focus();
        } finally {
          restoringFocus = false;
        }
      }

      // The legacy header also opens on focusin. Finalize closing after focus
      // returns to the trigger so neither focus handler can reopen the panel.
      window.clearTimeout(closeTimer);
      item.classList.remove('is-dropdown-open');
      setExpanded(item, false);
    }

    menuCloseHandlers.set(item, close);

    function scheduleClose() {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () {
        if (!item.matches(':hover') && !item.contains(document.activeElement)) {
          close();
        }
      }, 220);
    }

    function activate(tab, moveFocus) {
      var key = tab.getAttribute('data-ah-chair-tab');

      tabs.forEach(function (candidate) {
        var selected = candidate === tab;
        candidate.classList.toggle('is-selected', selected);
      });

      panels.forEach(function (panel) {
        var selected = panel.getAttribute('data-ah-chair-products') === key;
        panel.hidden = !selected;
        panel.classList.toggle('is-active', selected);
        if (selected) {
          loadRedirectedPreview(panel);
        }
      });

      if (moveFocus) {
        tab.focus();
      }
    }

    trigger.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowDown' || !isDesktop()) {
        return;
      }

      event.preventDefault();
      open();
      activate(tabs.find(function (tab) {
        return tab.classList.contains('is-selected');
      }) || tabs[0], true);
    });

    tabs.forEach(function (tab, index) {
      tab.addEventListener('pointerenter', function () {
        if (isDesktop()) {
          activate(tab, false);
        }
      });

      tab.addEventListener('focus', function () {
        if (isDesktop()) {
          activate(tab, false);
        }
      });

      tab.addEventListener('click', function () {
        activate(tab, false);
      });

      tab.addEventListener('keydown', function (event) {
        if (['ArrowDown', 'ArrowUp', 'Home', 'End'].indexOf(event.key) === -1) {
          return;
        }

        event.preventDefault();
        var nextIndex = index;

        if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = tabs.length - 1;
        } else if (event.key === 'ArrowDown') {
          nextIndex = (index + 1) % tabs.length;
        } else {
          nextIndex = (index - 1 + tabs.length) % tabs.length;
        }

        activate(tabs[nextIndex], true);
      });
    });

    item.addEventListener('pointerenter', open);
    item.addEventListener('pointerleave', scheduleClose);
    item.addEventListener('focusin', open);
    item.addEventListener('focusout', scheduleClose);
    menu.addEventListener('pointerenter', function () {
      window.clearTimeout(closeTimer);
    });

    var classObserver = new MutationObserver(function () {
      setExpanded(item, item.classList.contains('is-dropdown-open'));
    });

    classObserver.observe(item, {
      attributes: true,
      attributeFilter: ['class']
    });

    watchReviews(item);
  }

  function cleanMobileCopy(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.header-mb [data-ah-chair-panel]').forEach(function (panel) {
      panel.remove();
    });

    scope.querySelectorAll('.header-mb [data-ah-chair-menu]').forEach(function (item) {
      var trigger = item.querySelector('[data-ah-chair-trigger]');

      item.removeAttribute('data-ah-chair-menu');
      item.removeAttribute('data-ah-chair-ready');
      item.classList.remove('ah-chair-menu', 'is-dropdown-open');

      if (trigger) {
        trigger.removeAttribute('data-ah-chair-trigger');
        trigger.removeAttribute('aria-controls');
        trigger.removeAttribute('aria-haspopup');
        trigger.removeAttribute('aria-expanded');
      }
    });
  }

  function watchMobileCopy(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.header-mb .mn_mobile nav > ul').forEach(function (list) {
      if (list.hasAttribute('data-ah-chair-mobile-watch')) {
        return;
      }

      list.setAttribute('data-ah-chair-mobile-watch', 'true');

      new MutationObserver(function () {
        cleanMobileCopy(document);
      }).observe(list, {
        childList: true
      });
    });
  }

  function initializeAll(root) {
    var scope = root && root.querySelectorAll ? root : document;

    watchMobileCopy(scope);
    cleanMobileCopy(scope);

    scope.querySelectorAll('.header-bottom[data-sticky-pc] [data-ah-chair-menu]').forEach(initialize);

    if (scope.matches && scope.matches('.header-bottom[data-sticky-pc] [data-ah-chair-menu]')) {
      initialize(scope);
    }
  }

  // Capture Escape before the legacy header's bubbling handler clears its open
  // class. This also dismisses hover-only menus when keyboard focus is elsewhere.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !isDesktop()) {
      return;
    }

    document.querySelectorAll('.header-bottom[data-sticky-pc] [data-ah-chair-menu].is-dropdown-open').forEach(function (item) {
      var close = menuCloseHandlers.get(item);
      if (close) {
        event.preventDefault();
        close({ restoreFocus: item.contains(document.activeElement) });
      }
    });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAll(document);
    });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
}());
